import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { getLandingpagePath } from '../../routes/config';
import Image from '../../utils/Image';
import { Grid, Row, Col } from '../../utils/grid/Grid';

import './hero-image.css';

const externalLandingPages = ['ardennen', 'wellnesssuites'];

const HeroImageLink = ({ slug, buttonText }) => {
  if (!slug || !buttonText) {
    return null;
  }
  return (
    <Link
      className="hero-image-link"
      to={getLandingpagePath(slug)}
      reloadDocument={externalLandingPages.includes(slug)}
    >
      {buttonText}
    </Link>
  );
};

const HeroImage = ({ tall, image, title, description, ...props }) => (
  <div className={classNames('hero-image', { tall })}>
    <div className="hero-image-background">
      <Image src={image} className="hero-image-img" />
    </div>
    <div className="hero-image-foreground">
      <Grid>
        <Row bottom="md">
          <Col md>
            <div className="hero-image-inner">
              <h2 className="hero-image-title">{title}</h2>
              {description ? <p className="hero-image-desc">{description}</p> : null}
              <HeroImageLink {...props} />
            </div>
          </Col>
        </Row>
      </Grid>
    </div>
  </div>
);

HeroImage.propTypes = {
  tall: PropTypes.bool,
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
};

HeroImageLink.propTypes = {
  slug: PropTypes.string,
  buttonText: PropTypes.string,
};

export default HeroImage;
